module.exports = __webpack_public_path__ + "img/mako.383ff512.jpg";